import { render, staticRenderFns } from "./GraphDetail62.vue?vue&type=template&id=18dc418e&scoped=true"
import script from "./GraphDetail62.vue?vue&type=script&lang=js"
export * from "./GraphDetail62.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc418e",
  null
  
)

export default component.exports